export const ADJUSTMENT_CLASS = {
  INCREASE: "adjustment-increase",
  DECREASE: "adjustment-decrease",
};

export function getPriceAdjustmentConfig(priceAdjustment) {
  const isIncrease = priceAdjustment === "INCREASE";
  return {
    isIncrease,
    prefix: isIncrease ? "+" : "-",
    colorClass: isIncrease
      ? ADJUSTMENT_CLASS.INCREASE
      : ADJUSTMENT_CLASS.DECREASE,
  };
}
